
export const Globals = Object.freeze({
    DOMAIN_NAME: 'intranetsedic.es', // confident-moser.217-71-205-151.plesk.page
    //... more of your variables
});
